import { render, staticRenderFns } from "./List-Order-Pending.vue?vue&type=template&id=7e713345"
import script from "./List-Order-Pending.vue?vue&type=script&lang=js"
export * from "./List-Order-Pending.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports